<script lang="ts">
  import AssetShelf from './AssetShelf.svelte';
</script>
<div class="tym-page mx-auto w-full max-w-[1100px] space-y-6">
  <header><p class="tym-micro mb-1 text-toyama-teal">Catalogue / Documents</p><h2 class="tym-section-title !text-2xl">Marketing assets</h2><p class="tym-section-sub">Find published brochures and marketing PDFs. Category links are optional.</p></header>
  <AssetShelf kind="marketing" />
</div>
